import { MigratableJson } from '../MigratableJson';
import { FORM_NODE_NAME } from '@builder4/shared/utils/constants';

const WHITE_BACKGROUND = { r: 255, g: 255, b: 255, a: 1 };

/**
 * Migration v11: Add default backgroundColor to existing Form components
 *
 * This migration ensures backward compatibility after changing the Form component
 * to support transparent backgrounds (inheriting from parent container).
 *
 * For existing Form nodes that don't have a backgroundColor property (null or undefined):
 * - Sets backgroundColor to white to maintain current appearance
 * - This preserves the visual appearance of existing pages
 *
 * For new Form nodes created after this migration:
 * - backgroundColor defaults to undefined (transparent)
 * - Forms inherit background color from their parent container
 */
export default function toV11<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== FORM_NODE_NAME) {
      continue;
    }

    const props = { ...(node.props || {}) } as Record<string, unknown>;

    if (props.backgroundColor == null) {
      props.backgroundColor = WHITE_BACKGROUND;
    }

    if (props.tablet && typeof props.tablet === 'object') {
      const tabletProps = props.tablet as Record<string, unknown>;
      if (tabletProps.backgroundColor == null) {
        tabletProps.backgroundColor = WHITE_BACKGROUND;
      }
    }

    if (props.mobile && typeof props.mobile === 'object') {
      const mobileProps = props.mobile as Record<string, unknown>;
      if (mobileProps.backgroundColor == null) {
        mobileProps.backgroundColor = WHITE_BACKGROUND;
      }
    }

    node.props = props;
  }

  return data;
}
